import {
  createQuery,
  createSuspenseQuery
} from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

// Define the response schema based on the Swagger specification
const PublicViewSchema = z.object({
  // ID fields
  id: z.int(),
  board: z.int(),

  // String fields
  name: z.string().nullable(),
  icon: z.string().min(1).nullish(),
  color: z.string().nullable(),
  board_name: z.string().min(1),

  // Number fields
  order: z.number().min(0).max(2147483647),

  // Array fields
  available_stores: z.array(z.string().min(1))
});

type PublicView = z.infer<typeof PublicViewSchema>;
type Response = PublicView[];

const PublicViewsRequestSchema = z.object({
  slug: z.string()
});

type Request = z.infer<typeof PublicViewsRequestSchema>;

export const usePublicViews = createQuery<Response, Request, Error>({
  queryKey: ["publicViews"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<Request, Response>({
      method: "GET",
      url: `/public/:slug/boardviews/list`,
      requestSchema: PublicViewsRequestSchema,
      responseSchema: z.array(PublicViewSchema),
      body: variables
    });
  }
});

export const usePublicViewsWithSuspense = createSuspenseQuery<
  Response,
  Request,
  Error
>({
  queryKey: ["publicViews"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<Request, Response>({
      method: "GET",
      url: `/public/:slug/boardviews/list`,
      requestSchema: PublicViewsRequestSchema,
      responseSchema: z.array(PublicViewSchema),
      body: variables
    });
  }
});
